import { createRoutine } from "redux-saga-routines";

export const lockSkyBoxRoutine = createRoutine('LOCK_SKY_BOX_ROUTINE');
export const updateSkyBoxRoutine = createRoutine('UPDATE_SKY_BOX_ROUTINE');
export const getSkyBoxListRoutine = createRoutine('GET_SKY_BOX_LIST_ROUTINE');
export const simulateSignalRoutine = createRoutine('SIMULATE_SIGNAL_ROUTINE');
export const sendSignalRoutine = createRoutine('SEND_SIGNAL_ROUTINE');